import React,{Component} from 'react';
import './Footer.css';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { acri_st_logo_white, esa_logo_white } from '../../theme/images';
import { setGDPR } from '@acri-tools/react-tools/redux/reducers';
import { LoginState } from '@acri-tools/react-tools/redux/reducers/loginReducer';

interface Props{
    // ====== Redux ======
    login: LoginState
    setGDPR: any
}

class Footer extends Component<Props,{}>{
    state={
        from:'',
        subject:'',
        message:'',

        emailMessage:'',
        emailMessageType:'warn',
    }
    componentDidMount(){
        if(this.props.login.user){
            this.setState({
                from:this.props.login.user.email
            })
        }
    }
    render(){
        return (
            !isMobile &&
            <div id="footer">
                <div className="main-footer">

                    <div className="footer-container">
                        <div className="footer-logo">
                            <img alt="acri-st logo" src={acri_st_logo_white}/>
                            <img alt="esa logo" src={esa_logo_white}/>
                        </div>
                        <div className="footer-description">
                            The PDGS Data Archival, Management & Processing Services (DAMPS) is commissioned by the European Space Agency (ESA) under the Earthnet, 
                            the Long Term Data Preservation (LTDP-2) and the Mission Management Programmes following the contract 4000135398/21/I-LG
                        </div>
                    </div>

                </div>

                <div className="sub-footer">
                    <div className="rights">
                        <div className="rights-text">
                            © ACRI-ST 2023. All Rights Reserved.
                        </div>
                        <div className="rights-links">
                            <div className="custom-link" onClick={()=> this.props.setGDPR({ open: true }) }>
                                GDPR
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};


export default connect((state:any) =>{
    return {
        login: state.login
    }
},{
    setGDPR
})(Footer);
